import React, {useEffect} from 'react';
import { useQuery, gql } from '@apollo/client';

import { Link } from 'react-router-dom';
import { format } from 'date-fns';
import { GET_NOTES } from '../gql/query';
import LikeDislike from './LikeDislike';

const UserPosts = ({posts}) => {

  useEffect(() => {
    document.title = `${posts.name} Posts > ichor.by`;
  });

  const getExternalSource = (post) => {
    const sourceUrl = post.externalSource && typeof post.externalSource === 'string'
      ? post.externalSource
      : post.externalSource?.url;
    const sourceIcon = post.externalSource && typeof post.externalSource === 'object'
      ? post.externalSource.icon
      : null;
    const sourceHref = sourceUrl ? (sourceUrl.startsWith('http') ? sourceUrl : `https://${sourceUrl}`) : null;
    return { sourceUrl, sourceIcon, sourceHref };
  };

  let uname = posts.id;
  const isAuthenticated = !!localStorage.getItem('token');

  const {data, loading, error, fetchMore } = useQuery(GET_NOTES, 
    { variables: {
      limit: 10,
      qualifier: posts._id
    }, }
  );
  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error!</p>;

  return (
    <div className="cats_block">
    <div className="all-post-block">
      <div className="all_post">
        <span className="uname_weight">
          {posts.name} </span> Всего {posts.posts.length} записей
      </div>
    </div>
    <ul>
      {data.postFeed.posts.map(post => {
        const { sourceHref, sourceUrl, sourceIcon } = getExternalSource(post);
        return (
          <li key={post._id} className="mypost_li">
            <Link to={`/users/${uname}/post/${post._id}`}>
              <h1>{post.title}</h1>
            </Link>
            {sourceHref && (
              <div className="list-external-source">
                {sourceIcon ? (
                  sourceIcon.startsWith('http') ? (
                    <img src={sourceIcon} alt="source icon" />
                  ) : (
                    <span className="external-source-label">{sourceIcon}</span>
                  )
                ) : null}
                <a href={sourceHref} target="_blank" rel="noreferrer" onClick={(e) => e.stopPropagation()}>{sourceUrl}</a>
              </div>
            )}
            <div className="css-plank-cat">
          <Link  to={`/cats/${post.category._id}`}>
            {`${post.category.catname}`}
          </Link>
            <span>{format(new Date(post.createdAt), 'dd LLL yyyy')}</span>
            <span>👁️ {post.viewsCount}</span>
            <div style={{ marginLeft: 'auto', display: 'flex', gap: 12 }}>
              <LikeDislike
                targetId={post._id}
                type="post"
                initialLikes={post.likesCount || 0}
                initialDislikes={post.dislikesCount || 0}
                isAuthenticated={isAuthenticated}
              />
            </div>
          </div>
          </li>
        );
      })}
      </ul>

    {data.postFeed.hasNextPage && (
    <div className='clickMore' onClick={() =>
            fetchMore({
              variables: {
                cursor: data.postFeed.cursor
              },
              updateQuery: (previousResult, { fetchMoreResult}) => {
                
                return { postFeed: {
                  cursor: fetchMoreResult.postFeed.cursor,
                  hasNextPage: fetchMoreResult.postFeed.hasNextPage,
                  // combine the new results and the old
                  posts: [
                    ...previousResult.postFeed.posts,
                    ...fetchMoreResult.postFeed.posts
                  ],
                  __typename: 'postFeed'
                } };
              }
            })
}>more</div>)}
    </div>
  );
};

export default UserPosts;
